module.exports = __webpack_public_path__ + "img/channel-2-icon.114d2c66.png";